
export type UpdateUser403 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
